// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ooVVb","left":"styles_left__1iYfL"};